export default "__VITE_ASSET__CT8avgKZ__"